import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { scheduleModalsStyle } from './styles';
import { modalsStyle } from 'components/modal/styles';
import { FindSuccessItem, Images, PermissionList, RolePermission } from 'utils';
import { Break } from './break';
import { apptActionNames, DRIVE, SERVICE, STAFF, UNAVAILABLE } from '../../constants';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { ServiceAppt } from './serviceAppt';
import { Unavailable } from './unavailable';

export const CreateEvent = ({ handleOpenClose, date, modalDate, afterSuccess, fromCalendar }) => {
    const EDIT_TYPE = fromCalendar
        ? 'CREATE_APPOINTMENT'
        : modalDate?.actionType === apptActionNames.DUPLICATE
          ? 'CREATE_APPOINTMENT'
          : 'EDIT_APPOINTMENT';
    const classes = scheduleModalsStyle();
    const global = modalsStyle();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const [screenType, setScreenType] = useState(modalDate ? modalDate?.type : '');
    const success = FindSuccessItem(EDIT_TYPE);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(systemActions.getPlaces());
    }, []);

    useEffect(() => {
        if (info?.type) {
            const types =
                info?.type === SERVICE &&
                RolePermission([
                    PermissionList.APPT_SELF_CREATE?.code,
                    PermissionList.APPT_SERVICE_CREATE?.code,
                    PermissionList.APPT_CONNECTED_CREATE?.code,
                ])
                    ? SERVICE
                    : info?.type === STAFF &&
                        RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_STAFF_CREATE?.code])
                      ? STAFF
                      : info?.type === DRIVE &&
                          RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_DRIVE_CREATE?.code])
                        ? DRIVE
                        : // info?.type === BREAK && RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_BREAK_CREATE?.code]) ? BREAK :
                          // info?.type === PAID && RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_PTO_CREATE?.code]) ? PAID :
                          //     info?.type === UNPAID && RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_UNPAID_CREATE?.code]) ? UNPAID :
                          //         info?.type === SICK_TIME && RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_SICK_TIME_CREATE?.code]) ? SICK_TIME :
                          null;

            if (types) {
                setScreenType(types);
            }
        }
    }, [info]);

    useEffect(() => {
        if (success) {
            if (afterSuccess) {
                afterSuccess();
            }
            handleOpenClose();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_TYPE));
        }
    }, [success]);

    const handleChange = (type) => {
        setScreenType(type);
    };

    return (
        <div>
            {screenType ? (
                <div>
                    {screenType === SERVICE && (
                        <div className={classes.bigModal}>
                            <ServiceAppt
                                modalDate={modalDate?.actionType === apptActionNames.DUPLICATE ? null : modalDate}
                                duplicate={modalDate?.actionType === apptActionNames.DUPLICATE ? modalDate : null}
                                date={date}
                                handleOpenClose={handleOpenClose}
                            />
                        </div>
                    )}

                    {screenType === UNAVAILABLE && (
                        <div className={classes.bigModal}>
                            <Unavailable
                                modalDate={modalDate?.actionType === apptActionNames.DUPLICATE ? null : modalDate}
                                duplicate={modalDate?.actionType === apptActionNames.DUPLICATE ? modalDate : null}
                                date={date}
                                type={screenType}
                                handleOpenClose={handleOpenClose}
                            />
                        </div>
                    )}

                    {/*{screenType === STAFF &&*/}
                    {/*    <div className={classes.bigModal}>*/}
                    {/*        <StaffAppt*/}
                    {/*            modalDate={modalDate?.actionType === apptActionNames.DUPLICATE ? null : modalDate}*/}
                    {/*            duplicate={modalDate?.actionType === apptActionNames.DUPLICATE ? modalDate : null}*/}
                    {/*            date={date}*/}
                    {/*            type={screenType}*/}
                    {/*            handleOpenClose={handleOpenClose}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*}*/}

                    {screenType !== SERVICE && screenType !== UNAVAILABLE && (
                        <div className={classes.bigModal}>
                            <Break
                                modalDate={modalDate?.actionType === apptActionNames.DUPLICATE ? null : modalDate}
                                duplicate={modalDate?.actionType === apptActionNames.DUPLICATE ? modalDate : null}
                                date={date}
                                type={screenType}
                                handleOpenClose={handleOpenClose}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <div className={global.inactiveModalBody}>
                    <p className={global.availableScheduleTitle}>Select the Event Type</p>
                    <div className={classes.typesWrapper}>
                        {RolePermission([
                            PermissionList.APPT_SELF_CREATE?.code,
                            PermissionList.APPT_SERVICE_CREATE?.code,
                            PermissionList.APPT_CONNECTED_CREATE?.code,
                        ]) && (
                            <div onClick={() => handleChange(SERVICE)} className={classes.typesItem}>
                                <p>Service Appointment</p>
                                <img src={Images.forward} alt="icon" />
                            </div>
                        )}

                        {RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_STAFF_CREATE?.code]) && (
                            <div onClick={() => handleChange(STAFF)} className={classes.typesItem}>
                                <p>Staff Appointment</p>
                                <img src={Images.forward} alt="icon" />
                            </div>
                        )}

                        {RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_DRIVE_CREATE?.code]) && (
                            <div onClick={() => handleChange(DRIVE)} className={classes.typesItem}>
                                <p>Drive Time</p>
                                <img src={Images.forward} alt="icon" />
                            </div>
                        )}

                        {RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_UNAVAILABLE_CREATE?.code]) && (
                            <div onClick={() => handleChange(UNAVAILABLE)} className={classes.typesItem}>
                                <p>Unavailable Time</p>
                                <img src={Images.forward} alt="icon" />
                            </div>
                        )}

                        {/*{RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_SICK_TIME_CREATE?.code]) &&*/}
                        {/*    <div*/}
                        {/*        onClick={() => handleChange(SICK_TIME)}*/}
                        {/*        className={classes.typesItem}*/}
                        {/*    >*/}
                        {/*        <p>Sick Time</p>*/}
                        {/*        <img src={Images.forward} alt="icon" />*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_BREAK_CREATE?.code]) &&*/}
                        {/*    <div*/}
                        {/*        onClick={() => handleChange(BREAK)}*/}
                        {/*        className={classes.typesItem}*/}
                        {/*    >*/}
                        {/*        <p>Break</p>*/}
                        {/*        <img src={Images.forward} alt="icon" />*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_DRIVE_CREATE?.code]) &&*/}
                        {/*    <div*/}
                        {/*        onClick={() => handleChange(DRIVE)}*/}
                        {/*        className={classes.typesItem}*/}
                        {/*    >*/}
                        {/*        <p>Drive Time</p>*/}
                        {/*        <img src={Images.forward} alt="icon" />*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_PTO_CREATE?.code]) &&*/}
                        {/*    <div*/}
                        {/*        onClick={() => handleChange(PAID)}*/}
                        {/*        className={classes.typesItem}*/}
                        {/*    >*/}
                        {/*        <p>Paid Time Off</p>*/}
                        {/*        <img src={Images.forward} alt="icon" />*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{RolePermission([PermissionList.APPT_SELF_CREATE?.code, PermissionList.APPT_UNPAID_CREATE?.code]) &&*/}
                        {/*    <div*/}
                        {/*        onClick={() => handleChange(UNPAID)}*/}
                        {/*        className={classes.typesItem}*/}
                        {/*    >*/}
                        {/*        <p>Unpaid Time Off</p>*/}
                        {/*        <img src={Images.forward} alt="icon" />*/}
                        {/*    </div>*/}
                        {/*}*/}
                    </div>
                </div>
            )}
        </div>
    );
};
